import fetch from '@/utils/fetch';

export function dictCreate(params) {

    return fetch({
        // url: 'System/System/saveDataDictionary',
        url: 'manage/system/saveDataDictionary',
        method: "post",
        data: params
    })

}

export function getDistTree(params) {
    return fetch({
        //  url:'System/System/getDataDictionaryTree',
        url: 'manage/system/getDataDictionaryTree',
        method: "post",
        data: params
    })

}

export function dictRemove(params) {

    return fetch({
        // url: 'System/System/delDataDictionary',
        url: 'manage/system/delDataDictionary',
        method: "post",
        data: params
    })

}




// WEBPACK FOOTER //
// ./src/api/pgMent/dictMent.js